/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";

import style from "../styles/homepage.module.scss";
import BestProducts from "../components/homepage/BestProducts";
import Loader from "../components/shared/Loader";
import { GlobalContext } from "../context/GlobalContext";
import withHelmet from "../seo/withHelmet";
import { homepageHelmetProps } from "../seo/helmetProps";

const Homepage = () => {
  const { getHomepage, bestProducts, saleProducts } = useContext(GlobalContext);
  useEffect(() => {
    getHomepage();
  }, []);
  return (
    <>
      {bestProducts === undefined || saleProducts === undefined ? (
        <Loader />
      ) : (
        <div className={style.wrapper}>
          <BestProducts
            style={style}
            title="Më të shiturat"
            to="/shop?filter=top"
            products={bestProducts}
          />
          <BestProducts
            style={style}
            title="Me zbritje"
            to="/shop?filter=discount"
            products={saleProducts}
          />
        </div>
      )}
    </>
  );
};

export default withHelmet(Homepage, homepageHelmetProps);
